import { FilePreviewTag } from "components/FilePreviewTag/FilePreviewTag";
import { DownloadIcon } from "components/icons/Download";
import { useMultipleFileDetails } from "hooks/useMultipleFileDetails";

export const SensitiveDataFileList = ({ fileIds }: { fileIds: string[] }) => {
  const fileDetails = useMultipleFileDetails(fileIds);

  return (
    <>
      {fileDetails.map((file) => (
        <FilePreviewTag key={file.uuid} block file={file} size="small">
          <DownloadIcon color="currentColor" />
        </FilePreviewTag>
      ))}
    </>
  );
};
